import { Component, OnInit } from '@angular/core';
import { ApiService } from '../services/api.service';
import { LocalStorageService } from '../services/localstorage.service';
import { IBoard } from '../interfaces';
import { ActivatedRoute } from '@angular/router';
import { Communities } from '../services/communities.service';

@Component({
  selector: 'app-create-board',
  templateUrl: './create-board.component.html',
  styleUrls: ['./create-board.component.scss'],
  providers: [ApiService],
})
export class CreateBoardComponent implements OnInit {

	public boards : Array<IBoard> = [];
	public user: any = {};
	public publicBoards : Array<IBoard> = [];
	public publicBoardsComplex : Array<IBoard> = [];
  public searchInput : string = '';
  public category : string = '';
  public lang : string = 'fr';
  public categories : Array<Object> = [];

  constructor(
  	private _api: ApiService,
  	private _storage: LocalStorageService,
    private communities_service: Communities,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.lang = this.communities_service.getLanguage(this._storage.get('community_id'));

  	this.getBoards();
  	this.getPublicBoards();
  	this.getCategories();
    this.user = this._storage.getObject('user');
    console.log('user', this.user)
  }

  createFromTemplate(id: number) {
  	// console.log(id);
  }

  handleCategory (id) {
    console.log(id)
    this.category = id || '';
    this.handleSearch();
  }

  handleSearch () {
    this.getBoards()
    this.getPublicBoards()
  }

  getCategories () {
    this._api.boardCategories
  		.list()
  		.subscribe(
        (data) => {
        	this.categories = data.results;
        },
        (err) => { console.log(err); })
  }

  getBoards() {
    const community_id = this._storage.get('community_id') || this.route.snapshot.queryParams['community_id'];
    console.info('getBoards', community_id)
  	this._api.boards
  		.list({ search: this.searchInput, category: this.category, community: community_id, is_public: 0 })
  		.subscribe(
        (data) => {
        	this.boards = data.results;
        },
        (err) => { console.log(err); })
  };

  getPublicBoards() {
    console.info('getPublicBoards')
  	this._api.boards
    .list({ search: this.searchInput, category: this.category, is_public: 1, lang: this.lang })
  		.subscribe(
        (data) => {
        	this.publicBoardsComplex = data.results.filter(i => i.description).sort((a, b) => b.category ? 1 : -1);
        	this.publicBoards = data.results.filter(i => !i.description).sort((a, b) => b.category ? 1 : -1);
        },
        (err) => { console.log(err); })
  };

}



// WEBPACK FOOTER //
// /mnt/disk/stratbox.dev/src/app/create-board/create-board.component.ts